import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { flatMap } from 'rxjs/operators';

import { ConfigurationService } from '../../services/configuration.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-config',
  templateUrl: './config.page.html',
  styleUrls: ['./config.page.scss'],
})
export class ConfigPage implements OnInit {

  constructor(
    private config: ConfigurationService,
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit() {
    
        
    this.route.params.pipe(
      flatMap(params => {
        environment.cnpjRest = params.cnpj;
        return this.config.configV2({
          cnpj: params.cnpj,
          mode: params.mode,
          reference: params.tableNumber ? params.tableNumber : '0'
        })
      }),
      flatMap(() => {
        return this.config.initServices()
      })
    ).subscribe({
      next: () => this.router.navigate(['v2']),
      error: err => this.router.navigate(['sorry'])
    })
  }

}
